import React from 'react'
import { InputError, Toggle } from '@foodsby/nutrient'
import { Panel } from '../common/Layout'
import SimpleSpinner from '../common/SimpleSpinner'

const Heading = ({ text }) => <div className="notification-header">{text}</div>

export const NotificationPreference = ({
  notification,
  updateNotificationPreferenceStart,
}) => (
  <div className="notification-preference-type">
    <div className="row">
      <Heading text={notification && notification.channel.display} />
    </div>
    {notification &&
      notification.preferences.map((preference, i) => (
        <div className="row middle-xs" key={i}>
          <div className="col-xs-12 col-lg-9">
            <label htmlFor={i}>{preference.description}</label>
          </div>
          <div
            className="col-xs-12 col-lg-3 Toggle"
            style={{ paddingTop: '12px' }}
          >
            <Toggle
              checked={preference.enabled}
              name={preference.intentType}
              onChange={e =>
                updateNotificationPreferenceStart({
                  channelId: notification.channel.channelId,
                  intentId: preference.intentId,
                  enabled: e.target.checked,
                })
              }
            />
            <label htmlFor={preference.intentType} />
          </div>
        </div>
      ))}
  </div>
)

export const PanelNotificationPreferences = ({
  notificationPreferences,
  updateNotificationPreferenceStart,
  isLoadingNotificationPreferences,
  isUpdatingPreference,
  error,
}) => (
  <Panel>
    <h2 className="panel-title">Notification Preferences</h2>
    {isUpdatingPreference || isLoadingNotificationPreferences ? (
      <SimpleSpinner />
    ) : (
      <>
        {notificationPreferences && notificationPreferences.length >= 1
          ? notificationPreferences.map((notification, index) => (
              <NotificationPreference
                isUpdatingPreference={isUpdatingPreference}
                key={index}
                notification={notification}
                updateNotificationPreferenceStart={
                  updateNotificationPreferenceStart
                }
              />
            ))
          : null}
      </>
    )}
    {error && (
      <InputError visible={error && error !== null}>
        Oops! Something went wrong. If this continues to happen, please contact
        support.
      </InputError>
    )}
  </Panel>
)

export default PanelNotificationPreferences
